"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _close = _interopRequireDefault(require("../../icons/close"));
var _heading = _interopRequireDefault(require("../heading"));
var _icon = _interopRequireDefault(require("../icon"));
var _iconButton = _interopRequireDefault(require("../icon-button"));
var _sparkles = _interopRequireDefault(require("../../icons/sparkles"));
require("./tooltip.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var TooltipContent = function TooltipContent(_ref) {
  var bodyText = _ref.bodyText,
    closeButtonAriaLabel = _ref.closeButtonAriaLabel,
    headingLevel = _ref.headingLevel,
    headingText = _ref.headingText,
    iconPath = _ref.iconPath;
  var tooltipContentClassList = 'p3 sb-tooltip sb-tooltip__goldBorder sb-tooltip__caretGoldBorder';
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: tooltipContentClassList
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "mr2 self-start size1of12"
  }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    className: "color-gold",
    path: iconPath || _sparkles["default"]
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "sb-tooltip__verticalBorder pr2 size10of12"
  }, headingText ? /*#__PURE__*/_react["default"].createElement(_heading["default"], {
    className: "mb1 text-semibold",
    size: "xxs",
    tagName: headingLevel
  }, headingText) : null, bodyText ? /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-xxs",
    tabIndex: -1
  }, bodyText) : null), /*#__PURE__*/_react["default"].createElement("div", {
    className: "size1of12"
  }, /*#__PURE__*/_react["default"].createElement(_iconButton["default"], {
    ariaLabel: closeButtonAriaLabel,
    className: "color-textBlackSoft",
    path: _close["default"]
  }))));
};
var _default = exports["default"] = TooltipContent;